<script>
export default {
  name: "AppRedirection",
  mounted() {
    window.location.replace("https://www.fedex.com/payment/");
  },
};
</script>